import styled from "@emotion/styled";
import { Box } from "@stenajs-webui/core";

export const BoxWithPrintHide = styled(Box)`
  @media print {
    display: none !important;
  }
`;
